import { useTranslation } from 'react-i18next'
import { BeakerIcon } from '@heroicons/react/24/outline'

const fmt = (v) => (v === null || v === undefined ? '—' : Math.round(v * 10) / 10)

/** VH-224: a running experiment, or its stored before/after comparison. */
export default function ExperimentCard({ experiment, onEnd, ending = false }) {
  const { t } = useTranslation()
  if (!experiment) return null
  const c = experiment.comparison
  const running = experiment.status === 'running'

  return (
    <section className="bg-surface-container border rounded-lg p-4" data-testid="experiment-card">
      <div className="flex items-center gap-2 mb-2">
        <BeakerIcon className="h-5 w-5 text-purple-600" />
        <h3 className="text-sm font-semibold">{t('sleepRecovery.experiment.title')}</h3>
        <span className="ml-auto text-xs text-gray-500">{t(`sleepRecovery.experiment.status.${experiment.status}`)}</span>
      </div>
      <p className="text-sm">
        {t('sleepRecovery.experiment.started', { date: experiment.started_on, target: experiment.target_minutes })}
      </p>
      {running && (
        <button
          type="button" disabled={ending} onClick={() => onEnd?.(experiment.id)}
          className="mt-3 border rounded px-3 py-1.5 text-sm disabled:opacity-50"
        >
          {t('sleepRecovery.experiment.endEarly')}
        </button>
      )}
      {!running && c && (
        <div className="mt-3 space-y-2" data-testid="experiment-comparison">
          {c.ended_early && <p className="text-sm text-amber-700">{t('sleepRecovery.experiment.endedEarlyNote')}</p>}
          {!c.reliable && (
            <p className="text-sm text-amber-700" data-testid="experiment-unreliable">
              {t('sleepRecovery.experiment.unreliable', { nights: c.nights_during, min: c.min_reliable_nights })}
            </p>
          )}
          <p className="text-xs text-gray-500">
            {t('sleepRecovery.experiment.nights', { before: c.nights_before, during: c.nights_during, met: c.nights_meeting_target })}
          </p>
          <div className="overflow-x-auto">
            <table className="text-sm w-full">
              <thead>
                <tr className="text-left text-xs text-gray-500">
                  <th className="py-1">{t('sleepRecovery.experiment.metric')}</th>
                  <th>{t('sleepRecovery.experiment.before')}</th>
                  <th>{t('sleepRecovery.experiment.during')}</th>
                  <th>{t('sleepRecovery.experiment.difference')}</th>
                </tr>
              </thead>
              <tbody>
                {(c.metrics || []).map((m) => (
                  <tr key={m.key} className="border-t">
                    <td className="py-1">{t(`sleepRecovery.metrics.${m.key}`)}</td>
                    <td>{fmt(m.before_mean)} <span className="text-xs text-gray-500">({m.before_count})</span></td>
                    <td>{fmt(m.during_mean)} <span className="text-xs text-gray-500">({m.during_count})</span></td>
                    <td>{m.difference === null || m.difference === undefined ? '—' : `${m.difference > 0 ? '+' : ''}${m.difference}`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </section>
  )
}
